import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconAlimentosOn(props) {
    return (
        <svg
            width={242}
            height={243}
            viewBox="0 0 242 243"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx={121} cy={121} r={117} fill="#000" />
            <path
                d="M174.352 113.486V99.704h-30.779V68.916H102.53V56.593H65.591v12.313h-8.206V183.86H184.625v-53.967l-10.273-16.407zm-2.057 4.464l6.559 10.495h-13.118l6.559-10.495zm0 56.503l5.301 5.312h-10.612l5.311-5.312zm2.057-3.745v-29.939h-4.103v29.939l-6.16 6.161V132.56h6.16v4.104h4.103v-4.104h6.16v44.309l-6.16-6.161zm-4.103-58.68H127.15v-8.209h43.099v8.209zm-38.996-12.324V95.6h-4.103v4.104h-4.103v13.692l-4.104 5.472V75.927l8.207 8.208v7.36h4.103v-7.36l8.206-8.208v23.787h-8.206v-.01zm-20.516 57.482H61.478v-53.377h53.362v20.532l-4.103 5.472v27.373zm18.469-76.805l-7.357-7.36h14.715l-7.358 7.36zM98.417 68.916h-4.103v-8.209h4.103v8.21zm-20.526-8.209h4.103v8.21h-4.103v-8.21zm8.217 0h4.103v8.21h-4.103v-8.21zm-16.423 0h4.103v8.21h-4.103v-8.21zm-8.207 12.314h53.362v26.683H61.478V73.021zm0 88.27h49.259v18.474H61.478v-18.474zm53.362-30.109l11.281-15.05h42.47l-8.615 13.781v49.852H114.83v-48.583h.01z"
                fill="#FFDD00"
            />
            <path
                d="M118.943 173.604h36.939v-36.95h-36.939v36.95zm32.836-4.105h-28.732v-28.741h28.732v28.741z"
                fill="#FFDD00"
            />
            <path
                d="M137.413 165.395c4.532 0 8.206-3.685 8.206-8.209a8.284 8.284 0 00-1.637-4.923l-6.569-8.758-6.569 8.758a8.279 8.279 0 00-1.638 4.923c-.01 4.524 3.674 8.209 8.207 8.209zm-3.285-10.675l3.285-4.375 3.284 4.375c.53.709.819 1.587.819 2.466a4.104 4.104 0 11-8.206 0c0-.879.289-1.757.818-2.466zM106.624 112.028h-36.94v4.104h36.94v-4.104zM69.685 140.769h36.939v-20.533h-36.94v20.533zm4.103-16.428h28.732v12.313H73.788v-12.313zM106.624 144.873h-36.94v4.104h36.94v-4.104z"
                fill="#FFDD00"
                stroke="#FFDD00"
                strokeMiterlimit={10}
            />
            <path
                d="M121 242.081c-66.71 0-121-54.296-121-121.036C0 54.316 54.29 0 121 0c66.73 0 121 54.306 121 121.045-.01 66.74-54.28 121.036-121 121.036zm0-235.32C58.014 6.76 6.759 58.03 6.759 121.035 6.759 184.05 58.014 235.31 121 235.31s114.241-51.26 114.241-114.275C235.231 58.031 183.986 6.761 121 6.761z"
                fill="#000"
            />
            <path
                d="M181.101 36.89c0-10.706 8.695-19.374 19.388-19.374 10.702 0 19.368 8.668 19.368 19.374 0 10.685-8.666 19.373-19.368 19.373-10.693 0-19.388-8.688-19.388-19.373z"
                fill="#000"
            />
            <path
                d="M190.036 36.89c0-5.772 4.662-10.426 10.443-10.426 5.79 0 10.432 4.654 10.432 10.426a10.414 10.414 0 01-10.432 10.426c-5.781 0-10.443-4.674-10.443-10.426z"
                fill="#FFDD00"
            />
        </svg>
    )
}

export default SvgIconAlimentosOn;